// removed by extract-text-webpack-plugin
module.exports = {"searchHeaderSection":"searchPage-module_searchHeaderSection_NM7-_"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/search/searchPage.module.css
// module id = 504
// module chunks = 1 3